exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pricing-option{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;border:1px solid #7e7e7e}.pricing-option:not(:last-child){margin-bottom:15px}@media screen and (min-width:480px){.pricing-option:not(:last-child){margin-bottom:0;border-right:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/pricingoptions/pricingoption/pricingoption.styl
// module id = 506
// module chunks = 0